import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import React, { useState, useEffect } from "react";
import Approutes from "./routes/Approutes";
import Login from "./Views/Login/Login";
import ForgotPassword from "./Views/Login/ForgotPassword";
import ResetPassword from "./Views/Login/ResetPassword";
import FirstLogin from "./Views/FirstLogin";
import { ToastContainer } from "react-toastify";
import Navbar from "./components/Anchors/Navbar";
import Topbar from "./components/Anchors/Topbar";
import Footer from "./components/Anchors/Footer";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { SidebarProvider, useSidebar } from "./context/SidebarContext";
import ProtectedRoute from "./routes/ProtectedRoute";



// function Layout({ children }) {
//   const location = useLocation();

//   const hideNavbar = location.pathname === "/";
//   const hideTopBar = location.pathname === "/";
//   const hideFooter = location.pathname === "/";
//   return (
//     <div id="page-top">
//       <div id="wrapper">
//         {!hideNavbar && <Navbar />}
//         <div id="content-wrapper" className="d-flex flex-column">
//           <div id="content">
//             {!hideTopBar && <Topbar />}
//             <div className="container-fluid custom-container">{children}</div>
//           </div>
//           {!hideFooter && <Footer className="sticky-footer bg-white "/>}
//         </div>
//       </div>
//     </div>
//   );
// }

function Layout({ children }) {
  const location = useLocation();
  const { collapsed } = useSidebar();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1000);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1000);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const hideNavbar = location.pathname === "/";
  const hideTopBar = location.pathname === "/";
  const hideFooter = location.pathname === "/";
  
  return (
    <div id="page-top" className={collapsed && !isMobile ? "sidebar-toggled" : ""}>
      {isMobile && !hideNavbar && <Navbar />}
      <div id="wrapper">
        {!isMobile && !hideNavbar && <Navbar />}
        <div id="content-wrapper" className="d-flex flex-column" style={{ minHeight: "100vh" }}>
          <div id="content" style={{ flex: "1 0 auto" }}>
            {!hideTopBar && <Topbar />}
            <div className="container-fluid custom-container">{children}</div>
          </div>
          {!hideFooter && <Footer />}
        </div>
      </div>
    </div>
  );
}


function AppContent() {

  const { user, loading, isLoggedIn } = useAuth();
  const [theme, setTheme] = useState("light");

  useEffect(() => {

    // Valeurs attendues : dark | light | system
    // Valeur stockée
    const preferenceBDD = (user?.data?.theme || "system");

    // Résout le thème réellement appliqué à l'UI
    const resolveTheme = () => {
      // Si préférence explicite utilisateur, on l'applique directement
      if (preferenceBDD === "dark" || preferenceBDD === "light") {
        return preferenceBDD;
      }
      else {
        // Sinon (system), on suit la préférence système
        return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
      }
    };

    // Applique le thème au chargement
    setTheme(resolveTheme());

    // En mode system, on écoute les changements de thème du système en temps réel
    if (preferenceBDD === "system") {
      const handleSystemThemeChange = () => setTheme(resolveTheme());
      window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", handleSystemThemeChange);
      // Nettoyage du listener
      return () => window.matchMedia("(prefers-color-scheme: dark)").removeEventListener("change", handleSystemThemeChange);
    }
  }, [user?.data?.theme]);
  
  // Applique le thème final sur <html>
  useEffect(() => {
    document.documentElement.setAttribute("data-bs-theme", theme);
  }, [theme]);

  const rootElement = loading ? (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Chargement...</span>
      </div>
    </div>
  ) : isLoggedIn && user?.data ? (
    <Navigate to="/home" replace />
  ) : (
    <Login />
  );


  return (
    <Routes>
      <Route path="/" element={rootElement} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password/" element={<ResetPassword />} />
      <Route path="/first-login/:token" element={<FirstLogin />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Approutes />
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1000);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1000);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Router>
      <AuthProvider>
        <SidebarProvider>
          <ToastContainer
            position={isMobile ? "bottom-center" : "top-right"}
            autoClose={3000}
            hideProgressBar
            pauseOnHover
            draggable
            limit={1}
            style={isMobile ? { 
              width: "90vw",
              bottom: "20px"
            } : {}}
          />
          <AppContent />
        </SidebarProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
